import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

const _ = require("lodash");
const mapStateToProps = (state, props) => ({
  userState: state.app.userState
});

@connect(mapStateToProps)
class Permissions extends React.Component {
  props: {
    roles: Array<string>
  };

  static propTypes = {
    roles: PropTypes.array
  };

  static defaultProps = {
    roles: []
  };

  render() {
    let hasAccess =
      _.intersection(this.props.roles, this.props.userState.roles).length > 0;

    return hasAccess ? this.props.children : null;
  }
}

export default Permissions;



// WEBPACK FOOTER //
// ./src/components/LayoutComponents/Permissions/index.js